import unapply from "./unapply";
import identity from "./identity";

//  list :: a... -> [a...]
const list = unapply(identity);

export default list;
